import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BatchSearchEngineReducer } from '../reducers';

export const selectBatchSearchEngineFeature = createFeatureSelector<BatchSearchEngineReducer.BatchSearchEngineState>(BatchSearchEngineReducer.featureName);

export const selectItem = createSelector(selectBatchSearchEngineFeature, state => state.item);
